import { render, staticRenderFns } from "./OccupationSkillsTab.vue?vue&type=template&id=1469522f&scoped=true"
import script from "./OccupationSkillsTab.vue?vue&type=script&lang=js"
export * from "./OccupationSkillsTab.vue?vue&type=script&lang=js"
import style0 from "./OccupationSkillsTab.vue?vue&type=style&index=0&id=1469522f&scoped=true&lang=css"
import style1 from "./OccupationSkillsTab.vue?vue&type=style&index=1&id=1469522f&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469522f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1469522f')) {
      api.createRecord('1469522f', component.options)
    } else {
      api.reload('1469522f', component.options)
    }
    module.hot.accept("./OccupationSkillsTab.vue?vue&type=template&id=1469522f&scoped=true", function () {
      api.rerender('1469522f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/occupation-skill/OccupationSkillsTab.vue"
export default component.exports